import { useState } from 'react';
import { generateVaultSecret } from '../../../api';
import { notify } from '../../../app';
import { useModal, useRequest } from '../../../hooks';

export const useVaultSecret = (agentId: string) => {
  const {
    onOpen: onOpenSecretModal,
    onClose: onCloseSecretModal,
    isOpened: isOpenedSecretModal,
  } = useModal();
  const {
    onOpen: onOpenConfirmModal,
    onClose: onCloseConfirmModal,
    isOpened: isOpenedConfirm,
  } = useModal();

  const [vaulSecret, setVaultSecret] = useState(null);

  const [generateVaultApiSecret, generatingVaultSecret] = useRequest(
    _signal => {
      return generateVaultSecret({ agent_id: agentId });
    },
    {
      deps: [agentId],
      onSuccess: res => {
        onCloseConfirmModal();
        setVaultSecret(res?.secret);
        notify.success(res?.message);
        onOpenSecretModal();
      },
      onError: () =>
        notify.error('Failed to generate new API key. Please try again later'),
    }
  );

  return {
    generatingVaultSecret,
    generateVaultApiSecret,
    onOpenSecretModal,
    onCloseSecretModal,
    isOpenedSecretModal,
    onCloseConfirmModal,
    isOpenedConfirm,
    onOpenConfirmModal,
    vaulSecret,
    setVaultSecret,
  };
};
